import './phone-post-treatment-actions.ajscss';

import { IPhoneActionsService } from '@agent/agent-interface/contact-view/phone/phone-actions.service';
import { IOutgoingMailDeprecatedFacade } from '@agent/core/channel-digit/mail/outgoing-mail-deprecated.service';
import { ISmsDeprecatedService } from '@agent/core/channel-digit/sms/sms-deprecated.service';
import { IAppointmentDeprecatedService } from '@agent/core/contact/appointment-deprecated.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IQualificationDeprecatedService } from '@agent/core/contact/qualification-deprecated.service';
import { SessionDeprecatedService } from '@commons/core/auth/session-deprecated.service';
import { ICustomerCardsDeprecatedService } from '@commons/customer/customer-cards-deprecated.service';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { IComponentController, IComponentOptions, ILogService } from 'angular';

import {
  BookingPhoneFacade,
  ChannelDirection,
  ChannelType,
  CustomerFacade,
  DisplayDeprecatedComponent,
  MessagingService,
  Option,
  RecordFacade,
} from '@contact/upgrade';

import templateUrl from './phone-post-treatment-actions.template.html';

const MODULE_NAME = 'contactPhonePostTreatmentActions';

export class PhonePostTreatmentActionsCtrl extends DisplayDeprecatedComponent implements IComponentController {
  public name = MODULE_NAME;

  _recordRestricted: boolean = false;

  responseId: string;
  canRenewPostTreatment = false;
  canFinishPostTreatment = false;
  canRestrictRecord: boolean = false;

  hasCustomCardsSelectionDialog: boolean = false;

  constructor(
    protected readonly $log: ILogService,
    protected readonly contactDeprecatedService: IContactDeprecatedService,
    protected readonly phoneActions: IPhoneActionsService,
    protected readonly qualificationDeprecatedService: IQualificationDeprecatedService,
    protected readonly smsDeprecatedService: ISmsDeprecatedService,
    protected readonly appointmentDeprecatedService: IAppointmentDeprecatedService,
    protected readonly messaging: MessagingService,
    protected readonly $uibModal: any,
    protected readonly customerCardsDeprecatedService: ICustomerCardsDeprecatedService,
    protected readonly outgoingMailDeprecatedFacade: IOutgoingMailDeprecatedFacade,
    protected readonly customerFacade: CustomerFacade,
    protected readonly bookingPhoneFacade: BookingPhoneFacade,
    protected readonly sessionDeprecatedService: SessionDeprecatedService,
    protected readonly recordFacade: RecordFacade
  ) {
    super();
  }

  get isRecordRestricted(): boolean {
    return this._recordRestricted;
  }

  $onInit(): void {
    this.qualificationDeprecatedService.canRenewPostTreatment(this.responseId).then(can => (this.canRenewPostTreatment = can));
    this.qualificationDeprecatedService
      .canFinishPostTreatment(this.responseId)
      .pipe(ng1Destroy(this))
      .subscribe(can => (this.canFinishPostTreatment = can));

    // retrieve the customerCards if still not choosen by csr
    this.contactDeprecatedService.getContact(this.responseId).then(_contact => {
      let directionName: string = ChannelDirection[_contact.channel.direction];
      const mediaTypeName: string = ChannelType[_contact.channel.type];
      if (!_contact.customerId) {
        this.hasCustomCardsSelectionDialog = true;
        this.customerCardsDeprecatedService.displayPresomption(_contact.phoneNumber);
      }

      this.canRestrictRecord = this.sessionDeprecatedService.hasPermission(
        'CSR_' + mediaTypeName + '_' + directionName + '::csr_record:restrict'
      );
    });

    this.recordFacade
      .getByResponseId(this.responseId)
      .pipe(ng1Destroy(this))
      .subscribe(record => {
        this._recordRestricted = record?.restricted ?? false;
      });
  }

  $onDestroy(): void {
    if (this.hasCustomCardsSelectionDialog) {
      this.customerFacade.closeSelectDialog();
    }
  }

  finish(): void {
    this.phoneActions.finish(this.responseId);
  }

  renew(): void {
    this.phoneActions.renewPostTreatment(this.responseId).then(() => {
      this.qualificationDeprecatedService.canRenewPostTreatment(this.responseId).then(canRenew => {
        this.canRenewPostTreatment = canRenew;
      });
    });
  }

  openSMSForm(): void {
    this.contactDeprecatedService.getSelectedContact().then(contact => {
      contact.customerId && this.smsDeprecatedService.openSMSForContact(contact.customerId);
    });
  }

  openUnitMail(): void {
    this.contactDeprecatedService.getSelectedContact().then(contact => {
      this.outgoingMailDeprecatedFacade.openOutgoingMailForContactUuid(
        Option.of(contact.customerId).getOrElse(contact.customerId || ''),
        this.responseId
      );
    });
  }

  openAppointmentForm(): void {
    this.contactDeprecatedService.getSelectedContact().then(contact => {
      let firstName = contact.customerName;
      let lastName = '';
      this.appointmentDeprecatedService.openAppointmentForm(contact.responseId, contact.phoneNumber, firstName, lastName, contact.skills);
    });
  }

  setRecordRestricted() {
    this.bookingPhoneFacade.setRestrictedRecord(this.responseId);
  }

  unsetRecordRestricted() {
    this.bookingPhoneFacade.unsetRestrictedRecord(this.responseId);
  }
}

export class PhonePostTreatmentActions implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = [
    '$log',
    'contactDeprecatedService',
    'phoneActions',
    'qualificationDeprecatedService',
    'smsDeprecatedService',
    'appointmentDeprecatedService',
    'messaging',
    '$uibModal',
    'customerCardsDeprecatedService',
    'outgoingMailDeprecatedService',
    'customerFacade',
    'bookingPhoneFacade',
    'sessionDeprecatedService',
    'recordFacade',
    PhonePostTreatmentActionsCtrl,
  ];
}

export default MODULE_NAME;
